import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

function Industries() {
  const [isSlider, setIsSlider] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSlider(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const industriesData = [
    { icon: "🏥", name: "Healthcare" },
    { icon: "🏦", name: "BFSI & Fintech" },
    { icon: "🛒", name: "E-Commerce" },
    { icon: "🏗️", name: "Real Estate" },
    { icon: "🎓", name: "EdTech" },
    { icon: "🚗", name: "Automotive" },
    { icon: "📱", name: "SaaS" },
    { icon: "🏭", name: "Manufacturing" },
    { icon: "🚚", name: "Logistics" },
    { icon: "🍽️", name: "Hospitality" },
    { icon: "📺", name: "Media" },
    { icon: "💼", name: "Consulting" },
  ];

  return (
    <section id="industries" className="industries-section">
      <div className="container">

        {/* Header */}
        <div className="industries-header">
          <span className="section-label">INDUSTRIES WE SERVE</span>
          <h2 className="section-title">Data for Every Industry</h2>
          <p className="section-sub">
            If your business runs on decisions, Datroniq has the data that powers them.
          </p>
        </div>

        {/* 🔁 CONDITION */}
        {isSlider ? (

          /* SLIDER (Mobile + Laptop) */
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={15}
            autoplay={{ delay: 2500 }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 2 },
              576: { slidesPerView: 3 },
              768: { slidesPerView: 5 },
            }}
          >
            {industriesData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="industry-card">
                  <span>{item.icon}</span>
                  <p>{item.name}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        ) : (

          /* GRID (Desktop Only) */
          <div className="industries-grid">
            {industriesData.map((item, index) => (
              <div className="industry-card" key={index}>
                <span>{item.icon}</span>
                <p>{item.name}</p>
              </div>
            ))}
          </div>

        )}

      </div>
    </section>
  );
}

export default Industries;